const VEHICLE = {
    CONDITIONS: {
        NEW: 0x1,
        DEMO: 0x3,
        USED: 0x100,
        CERTIFIED: 0x300,
    },
};

export default VEHICLE;



// WEBPACK FOOTER //
// ./src/constants/vehicle.js